import store from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Sets the input text of the IncludesWordsInput text field
 * @param clauseId the id of the clause that corresponds to the input
 * @param inputText the current text in the input field
 */
export default action('setFocusedClauseId')(function setFocusedClauseId(clauseId, shouldSetAsFocused) {
    store.inboxRulesEditState.focusedClauseId = shouldSetAsFocused ? clauseId : '';
});
//# sourceMappingURL=setFocusedClauseId.js.map